export default __webpack_public_path__ + "static/media/icon-avatar-college.8dabb793.svg";